import ApiUtil from '../util/ApiUtil';
import Constants from '../constants/Constants';

const encodeBaseUrl = '/api/v1/encode';

const cancelVideoEncoding = async (mediaHash: string) => await ApiUtil.executeDeleteAsync(`${encodeBaseUrl}/${mediaHash}`, [Constants.statusCodes.noContent]);

export default {
   cancelVideoEncoding
};
